import {
  createAlert,
  CREATE_ALERT,
  REMOVE_ALERT
} from '../actions/alertActions'

function canCreateAlert(action) {
  return (
    action.alert && action.type !== CREATE_ALERT && action.type !== REMOVE_ALERT
  )
}

export default function alertMiddleware({ dispatch }) {
  return next => action => {
    const result = next(action)

    if (canCreateAlert(action)) {
      dispatch(createAlert(action.alert))
    }

    return result
  }
}



// WEBPACK FOOTER //
// ../src/middleware/alert.js